import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {ApprovalsMiniStatus} from './mini-merge-sections/ApprovalsMiniStatus'
import {ChecksMiniStatus} from './mini-merge-sections/ChecksMiniStatus'
import {CommentsMiniStatus} from './mini-merge-sections/CommentsMiniStatus'
import styles from './mini-merge-sections/MiniMergeSections.module.css'
import {useMergeabilityData} from './use-mergeability-data'
import {Suspense} from 'react'
import {Stack} from '@primer/react'
import {MiniMergeStatusSkeleton} from './mini-merge-sections/MiniMergeStatusLoading'

export function MiniOverviewMergeStatus() {
  const data = useMergeabilityData()

  if (!data || data.isClosedOrMerged) {
    return null
  }

  const {statusRollup, reviewerSection} = data

  return (
    <Stack
      as="section"
      direction={{narrow: 'vertical', regular: 'horizontal'}}
      className={styles.MiniOverviewMergeStatus}
      gap="none"
      aria-label="Merge status"
    >
      <ChecksMiniStatus statusRollup={statusRollup} />
      <CommentsMiniStatus />
      <ApprovalsMiniStatus reviewerSection={reviewerSection} />
    </Stack>
  )
}

export function MiniMergeStatusBoundary({children}: {children: React.ReactNode}) {
  return (
    <ErrorBoundary boundaryName="MiniMergeStatusBoundary" fallback={null}>
      <Suspense fallback={<MiniMergeStatusSkeleton />}>{children}</Suspense>
    </ErrorBoundary>
  )
}
